import v1 from './v1'

export default {
    v1
}
